module.exports = __webpack_public_path__ + "static/media/Diners.d4a44712.svg";